<template>
	<div class="honda-flat-rate-search-view">
		<SectionHeader
			class="honda-flat-rate-search-view__title"
			sectionText="Labor Operation Code Search"
			variant="defaultBg2"
		/>
		<Card class="honda-flat-rate-search-view__card">
			<template slot="card-body">
				<div class="honda-flat-rate-search-view__id-container">
					<StaticField
						class="honda-flat-rate-search-view__vin"
						variant="leftLabel"
						data-testid="vin-field"
					>
						<template #label>
							VIN:
						</template>
						<template #value>
							{{ vin }}
						</template>
					</StaticField>
					<StaticField
						class="honda-flat-rate-search-view__year"
						variant="leftLabel"
						data-testid="year-field"
					>
						<template #label>
							Year:
						</template>
						<template #value>
							{{ modelYear }}
						</template>
					</StaticField>
					<StaticField
						class="honda-flat-rate-search-view__model"
						variant="leftLabel"
						data-testid="model-field"
					>
						<template #label>
							Model:
						</template>
						<template #value>
							{{ modelName }}
						</template>
					</StaticField>
				</div>
			</template>
		</Card>

		<div class="honda-flat-rate-search-view__search-container">
			<Search
				class="honda-flat-rate-search-view__search"
				v-model="laborSearchData"
				@search="onLaborSearch"
				placeholder="Search Keyword/Labor Code"
				width="315px"
			/>

			<span
				class="honda-flat-rate-search-view__count"
				data-testid="result-field"
				>{{ formatNumber(resultCount) }} Results</span
			>
		</div>
	</div>
</template>

<script>
import Search from '@/components/forms/search/search.vue';
import SectionHeader from '@/components/typography/section-header/section-header.vue';
import StaticField from '@/components/forms/static-field/static-field.vue';
import Card from '@/components/shells/card/card.vue';
import { formatInt } from '@/utils/number-format-functions';

export default {
	name: 'HondaFlatRateSearch',
	components: {
		Search,
		SectionHeader,
		StaticField,
		Card
	},
	data() {
		return {
			laborSearchData: null
		};
	},
	props: {
		vin: {
			type: String,
			default: null
		},
		modelYear: {
			type: Number,
			default: null
		},
		modelName: {
			type: String,
			default: null
		},
		resultCount: {
			type: Number,
			default: 0
		}
	},
	methods: {
		onLaborSearch() {
			this.$emit('laborSearch', {
				searchText: this.laborSearchData
			});
		},
		formatNumber(value) {
			return formatInt(value);
		}
	}
};
</script>

<style lang="scss" scoped>
.honda-flat-rate-search-view {
	display: flex;
	flex-direction: column;
	gap: $gutter-lg;

	&__card {
		margin-bottom: $gutter-lg;
	}

	&__id-container {
		display: flex;
		align-items: center;
		gap: $gutter-xxxl;
	}

	&__search-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	&__count {
		font-size: $txt-font-size;
		color: var(--bg-0-fg-3);
	}
}
</style>
